import axios from "axios";
import { prompt } from "./../../Control/Vue/Notifications/Prompts";

export class EndFriendshipButton {
	protected readonly endFriendshipButton: JQuery;
	private readonly removeFriendUrl: string;
	private readonly errorMessage: string;
	private loading = false;

	constructor(button: JQuery) {
		this.endFriendshipButton = button;
		this.removeFriendUrl = button.data("url");
		this.errorMessage = button.data("error-request-fail");
		this.endFriendshipButton.on("click", (event) => void this.onButtonClick(event));
	}

	private async onButtonClick(event: JQuery.Event): Promise<void> {
		event.preventDefault();

		if (this.loading) {
			return;
		}

		this.loading = true;
		try {
			await axios.get(this.removeFriendUrl, { skipDefaultErrorHandler: true });
			jQuery(".mia-ChildProfile-endFriendship").remove();
			jQuery(".mia-endFriendshipModal").modal("hide");
		}
		catch {
			prompt(this.errorMessage);
		}
		finally {
			this.loading = false;
		}
	}
}
